<div class="ontario-alert ontario-alert--error">
    <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
            <mat-icon aria-hidden="true">error</mat-icon>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">Session Expired</h2>
        <div class="close-alert">
            <button mat-icon-button matTooltip="Close" aria-label="Close" (click)="close()">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </div>
    <div class="ontario-alert__body">
        <p>
            Your session has expired. Please sign in again to continue.
        </p>

        <div class="mt-2">
            <button mat-raised-button color="primary" (click)="signIn()">Sign-In</button>
        </div>
    </div>
</div>

